import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web--source/common/pete/TraceEventTracker';

export const eventKey = 'brand_leads-trust_pilot_badge-view';

/**
 * Event track the views of trust pilot badge on brand landing page
 */
export function trackBrandLeadsTrustPilotBadgeView(): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
  });
}
